module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/resources/theme/custom_omega/fonts/roboto-v15-latin-regular.woff
// module id = ../../../../../resources/theme/custom_omega/fonts/roboto-v15-latin-regular.woff
// module chunks = 2